<template>
  <div v-on-click-outside="closeMenu" class="dropdown">
    <span v-if="label">{{ label }}</span>

    <button v-focus class="dropdown-select" @click="toggleMenu()">
      {{ model }}
      <i
        class="dropdown-select__arrow fa-solid"
        :class="isMenuOpen ? ' fa-chevron-up' : ' fa-chevron-down'"
      />
    </button>

    <transition name="dropdown-fade">
      <ul v-if="isMenuOpen" class="dropdown-options">
        <li
          v-for="option in options"
          :key="option"
          v-focus
          tabindex="0"
          class="dropdown-option"
          :class="{ 'dropdown-option--active': option === model }"
          @click="selectOption(option)"
          @keydown.enter.prevent="selectOption(option)"
          @keydown.escape.prevent="closeMenu"
        >
          {{ option }}
        </li>
      </ul>
    </transition>
  </div>
</template>

<script setup>
import { useToggleMenu } from "@follaw-fr/composables/useToggleMenu";
import { vOnClickOutside } from "@vueuse/components";

const { isMenuOpen, toggleMenu, closeMenu } = useToggleMenu();
const model = defineModel({ type: String, default: "" });
defineProps({
  options: {
    type: Object,
    required: true,
  },
  label: {
    type: [String, Number],
    default: "",
  },
});

const selectOption = (option) => {
  model.value = option;
  closeMenu();
};
</script>

<style lang="scss" scoped>
.dropdown {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}

.dropdown-select {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  background-color: #ffffff;
  box-shadow: 0px 2px 10px 0px #00000014;
  border-radius: 17px;
  padding: 4px 8px;
  width: 100%;

  &__arrow {
    margin-left: 8px;
  }
}

.dropdown-options {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 4px;
  margin: 4px 0 0 0;
  position: absolute;
  top: 100%;
  right: 0;
  overflow: hidden;
  background-color: #ffffff;
  box-shadow: 0 1px 6px #0000005d;
  border-radius: 4px;
  list-style: none;
  z-index: 1;
  width: auto;
}

.dropdown-option {
  padding: 4px 8px;
  cursor: pointer;

  &:hover {
    background-color: var(--clr-n3);
  }

  &--active {
    background-color: var(--clr-p2);
  }
}

.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
  transition: opacity 0.2s;
}
.dropdown-fade-enter-from,
.dropdown-fade-leave-to {
  opacity: 0;
}
</style>
